import { useMutation } from "@tanstack/react-query"

import { axiosClient } from "$/http"

import { Urls } from "../urls"

export function useSubmitEnrollment(participantId: number) {
    return useMutation({
        mutationFn: (moduleId: number) =>
            axiosClient.post<{ id: number }>(Urls.submitModuleEnrollment(participantId), { module: moduleId })
    })
}
